<app-signing-order-editor [itemsFormArray]="form" labelKey="name" [sortable]="templateType !== templateTypes.Document">
  <ng-template signerForm let-form="form" let-isFlat="isFlat" let-index="index" let-draggable="draggable">
    <app-signer-item-form
      [class.flat]="isFlat"
      [form]="form"
      [role]="form.get('role').value"
      [isGuestEnabled]="(isGuestRole | call : form.get('role').value) || !(isUserRole | call : form.get('role').value)"
      [isUserEnabled]="(isUserRole | call : form.get('role').value) || !(isGuestRole | call : form.get('role').value)"
      [draggable]="draggable"
      [removable]="false"
      [setFormDataFunc]="onSignerSelect"
    >
    </app-signer-item-form>
  </ng-template>
</app-signing-order-editor>
